import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    padding: 8,
    borderRadius: 8,
  },
  headerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 70,
    paddingTop: 10,
    paddingRight: 5,
    alignContent: 'center',
  },
  patientWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
  },
  noPatients: {
    fontFamily: 'InterSemiBold',
    color: colors.newUI.therapist.grey60,
    alignItems: 'center',
    margin: 'auto',
    marginBottom: 10,
  },
});

export default style;
